import {ApplicationRef, createComponent, inject, Injectable, Injector, Type} from '@angular/core';
import {Modal} from '@shared/components/modal/modal';
import {ModalRef} from '@shared/components/modal/modal.ref';
import {ModalConfig} from '@shared/components/modal/modal.config';
import {MODAL_CONFIG} from '@shared/components/modal/modal.token';

@Injectable({ providedIn: 'root' })
export class ModalService {

  private appRef = inject(ApplicationRef);
  private injector = inject(Injector);

  open<T, R = any>(
    component: Type<T>,
    config?: ModalConfig
  ): ModalRef<R> {

    const modalRef = new ModalRef();

    const modalInjector = Injector.create({
      providers: [
        { provide: ModalRef, useValue: modalRef },
        { provide: MODAL_CONFIG, useValue: config }
      ],
      parent: this.injector
    });

    const containerRef = createComponent(Modal, {
      environmentInjector: this.appRef.injector,
      elementInjector: modalInjector
    });

    this.appRef.attachView(containerRef.hostView);

    document.body.appendChild(
      containerRef.location.nativeElement
    );

    containerRef.instance.modalRef = modalRef;
    containerRef.instance.childComponentType = component;

    modalRef.afterClosed().subscribe(() => {
      this.appRef.detachView(containerRef.hostView);
      containerRef.destroy();
    });

    return modalRef;
  }
}
